import { Component, inject } from '@angular/core';
import { ArticleSearchBarComponent } from '../article-search-bar/article-search-bar.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-dialog',
  imports: [
    ArticleSearchBarComponent,
    FaIconComponent,
    MatButton,
  ],
  templateUrl: './search-dialog.component.html',
  styleUrl: './search-dialog.component.scss',
})
export class SearchDialogComponent {
  private _dialog = inject(MatDialogRef);

  protected close() {
    this._dialog.close();
  }

  protected readonly faClose = faClose;
}
